var _ = require('lodash');

(function Module() {
	'use strict';

	mySynch.directive('breadcrumb', function checkonline() {
		return {
			restrict : "E",
			scope: {
				breadcrumbs: '=',
				lastbreadcrumburl: '@',
				lastbreadcrumbname: '@',
			},
			template:
				'<span ng-repeat="breadcrumb in breadcrumbs">' +
					'<a class="text-underline link-bredum" href="{{breadcrumb.url}}">{{breadcrumb.name}}</a>' +
					'<span class="sol">&sol;</span>' +
				'</span>' +
				'<span class="link-bredum" href="{{lastbreadcrumburl}}">{{lastbreadcrumbname}}' +
				'</span>'
		};
	});
})();
